import React from 'react';
import Page from '../../components/Page';
import { Building2 } from 'lucide-react';

const DistributionCentersOverviewPage: React.FC = () => {
  return (
    <Page
      title="🏢 Centros de Distribuição - Visão Geral"
      subtitle="Dashboard principal dos Centros de Distribuição"
      onRefresh={() => window.location.reload()}
    >
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-center">
          <Building2 
            className="h-16 w-16 mx-auto mb-4" 
            style={{ color: 'var(--primary)' }}
          />
          <h2 
            className="text-2xl font-semibold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            Centros de Distribuição - Em Desenvolvimento
          </h2>
          <p 
            style={{ color: 'var(--text-secondary)' }}
          >
            Esta página será implementada em breve
          </p>
        </div>
      </div>
    </Page>
  );
};

export default DistributionCentersOverviewPage;
